<template>
  <div class="footer">
      <div class="banxin">
        <div class="top">
            <!-- 左侧：Logo和公司名 -->
            <div class="leftBox">
                <div class="logoBox">
                    <img src="../../../static1/shenxizhixuan-logo2.png" alt="身析智选">
                    <!-- <span class="logoText">身析智选</span> -->
                </div>
                <p class="companyName">杭州身析智选电子商务有限公司</p>
            </div>
            <!-- 关注身析智选 -->
            <div class="centerBox">
                <p class="title"><span class="divider"></span>关注身析智选</p>
                <p>专注于客单价，转化率提升！</p>
                <p>便捷高效，助力各大商家提升客单价，</p>
                <p>客户引导，提高复购，</p>
                <p>只为更好的服务每一位用户。</p>
            </div>
            <!-- 关于我们 -->
            <div class="aboutBox">
                <p class="title"><span class="divider"></span>关于我们</p>
                <!-- <p class="cur-poi">关于我们</p>
                <p class="cur-poi">了解我们</p>
                <p class="cur-poi">合作咨询</p> -->
                <p class="cur-poi" @click="privacyPolicy">《隐私政策》</p>
            </div>
            <!-- 联系我们 -->
            <div class="contactBox">
                <p class="title"><span class="divider"></span>联系我们</p>
                <p class="contactItem">
                    <i class="iconfont">&#xe62f;</i>
                    <span>132 9148 9151</span>
                </p>
                <p class="contactItem">
                    <i class="iconfont">&#xe62e;</i>
                    <span>1754598331@qq.com</span>
                </p>
                <p class="contactItem address">
                    <i class="iconfont">&#xe631;</i>
                    <span>浙江省杭州市临安区颐康街8号杭州医学院临安校区18幢1号楼19号工位</span>
                </p>
            </div>
        </div>
      </div>
      <div class="bottomBar">
        <div class="banxin">
            <span>&copy;2025杭州身析智选电子商务有限公司 版权所有</span>
            <div class="right">
                <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备2025210396号-3A</a>
                <span class="brand">身析智选</span>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {
    // 阅读协议
    privacyPolicy () {
      // this.dialogAgreement = true
      window.open('https://jiankangjia.online/pc/static1/身析智能APP隐私协议.docx', '_blank')
    },
},
}
</script>
<style lang = "scss" scoped>
.footer{
    width: 100%;
    background-color: #0D0D0D;
    color: #FFFFFF;
    overflow: hidden;
    .banxin{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
    }
    .top{
        padding: 60px 0 50px 0;
        display: flex;
        justify-content: space-between;
        .leftBox{
            width: 220px;
            .logoBox{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                margin-left: -70px;
                img{
                    width: 200px;
                    // height: 48px;
                    margin-right: 12px;
                }
                .logoText{
                    font-size: 24px;
                    font-weight: bold;
                    color: #C5AA7B;
                }
            }
            .companyName{
                font-size: 14px;
                color: #999999;
                line-height: 1.6;
            }
        }
        .centerBox{
            width: 260px;
            .title{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 24px;
                display: flex;
                align-items: center;
                .divider{
                    display: inline-block;
                    width: 24px;
                    height: 2px;
                    background-color: #C5AA7B;
                    margin-right: 10px;
                }
            }
            p{
                font-size: 14px;
                color: #999999;
                line-height: 28px;
            }
        }
        .aboutBox{
            width: 180px;
            .title{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 24px;
                display: flex;
                align-items: center;
                .divider{
                    display: inline-block;
                    width: 24px;
                    height: 2px;
                    background-color: #C5AA7B;
                    margin-right: 10px;
                }
            }
            p{
                font-size: 14px;
                color: #999999;
                margin-bottom: 16px;
                &.cur-poi{
                    cursor: pointer;
                    transition: color 0.3s;
                    &:hover{
                        color: #C5AA7B;
                    }
                }
            }
        }
        .contactBox{
            width: 280px;
            .title{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 24px;
                display: flex;
                align-items: center;
                .divider{
                    display: inline-block;
                    width: 24px;
                    height: 2px;
                    background-color: #C5AA7B;
                    margin-right: 10px;
                }
            }
            .contactItem{
                font-size: 14px;
                color: #999999;
                margin-bottom: 14px;
                display: flex;
                align-items: flex-start;
                .iconfont{
                    margin-right: 10px;
                    color: #C5AA7B;
                    font-size: 14px;
                }
                &.address{
                    line-height: 1.6;
                }
            }
        }
    }
    .bottomBar{
        background-color: #050505;
        padding: 20px 0;
        .banxin{
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            color: #666666;
            span, a{
                color: #666666;
            }
            a:hover{
                color: #C5AA7B;
            }
            .right{
                display: flex;
                align-items: center;
                a{
                    margin-right: 20px;
                }
                .brand{
                    color: #C5AA7B;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footer.vue